/**
 * Can the current user run the Commissions config/upload/reports? App admin OR
 * the per-tool approver/approver_admin role. Mirrors requireCommissionsAdmin.
 */
import { useProfile } from '../profile/ProfileProvider';

export function useIsCommissionsAdmin(): boolean {
  const { state } = useProfile();
  if (state.status !== 'ready') return false;
  if (state.isAdmin) return true;
  const role = state.user.tools?.commissions?.role;
  return role === 'approver' || role === 'approver_admin';
}
